import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { onValue, ref, Unsubscribe } from 'firebase/database';
import { db } from '../firebase';

import { AppDispatch } from './index';
import { consumptionActions } from './consumptions';

type Listener = {
  path: string;
  unsubscribe: Unsubscribe;
};

let listeners: Listener[] = [];

interface ListenerState {
  listenerPaths: string[];
}

const initialState: ListenerState = {
  listenerPaths: [],
};

const listenerSlice = createSlice({
  name: 'listeners',
  initialState,
  reducers: {
    storeListener(state, action: PayloadAction<string>) {
      if (state.listenerPaths.includes(action.payload)) {
        return;
      }
      state.listenerPaths.push(action.payload);
    },
    removeListener(state, action: PayloadAction<string>) {
      let listenerIndex = state.listenerPaths.findIndex(p => p === action.payload);
      if (listenerIndex !== -1) {
        state.listenerPaths.splice(listenerIndex, 1);
      }
      listenerIndex = listeners.findIndex(l => l.path === action.payload);
      if (listenerIndex !== -1) {
        listeners[listenerIndex].unsubscribe();
        listeners.splice(listenerIndex, 1);
      }
    },
    removeListeners(state) {
      state.listenerPaths = [];
      listeners.forEach(l => l.unsubscribe());
      listeners = [];
    },
  },
});

export const startConsumptionsListener = () => (dispatch: AppDispatch) => {
  if (listeners.find(l => l.path === 'consumptions/')) {
    return;
  }

  const unsubscribeFunction = onValue(ref(db, 'consumptions/'), snapshot => {
    dispatch(consumptionActions.clearConsumptions());
    if (snapshot.exists()) {
      for (const [key, value] of Object.entries(snapshot.val())) {
        const data = value as { name: string; score: number };
        dispatch(
          consumptionActions.updateConsumption({
            id: key,
            name: data.name,
            score: data.score,
          })
        );
      }
    }
  });
  listeners.push({ path: 'consumptions/', unsubscribe: unsubscribeFunction });

  dispatch(listenerActions.storeListener('consumptions/'));
};

export const listenerActions = listenerSlice.actions;
export default listenerSlice.reducer;
